import workflow from "@/views/Workflow"
import list from "@/views/Workflow/list"
import steps from "@/views/Workflow/steps/index.vue"
import send from "@/views/Workflow/send"
import workflowMaintForm from "@/views/Workflow/workflowMaintForm"


export default {
    path: "/Workflow",
    component: workflow,
    children: [{
        path: ":systemCode",
        component: list
    }, {
        path: ":systemCode/Steps/:id",
        component: steps
    }, {
        path: ":systemCode/maint/:id",
        component: workflowMaintForm
    }, {
        path: ":systemCode/send/:id",
        component: send
    }]
}